import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AttendanceContact, AttendanceContactInfo, AttendanceGridRow, IAttendanceContactGridData, IAttendanceGridRow } from 'attendance/model/attendance.model';
import { InputControllerTypes } from 'common/enums';
import { valueToControllerType } from 'common/helper';
import { DetailInfo } from 'common/model';
import { generateFormGroupForDetailInfo } from 'shared/shared.helper';

export interface IContactListColumnSchems {
  key: string;
  title: string;
  sortable: boolean;
  detailInfo: DetailInfo,
  formGroup: FormGroup
}

export const prepareColmnSchema = (
  attendanceContactInfos: ReadonlyArray<AttendanceContactInfo>,
): ReadonlyArray<IContactListColumnSchems> => {
  const contactInfo = [...attendanceContactInfos].sort((a, b) => a.gridOrder - b.gridOrder);

  return contactInfo.map(item => ({
    key: item.evideInputContentGuid,
    sortable: false,
    title: item.shortTitle,
    detailInfo: item.detailInfo,
    formGroup: new FormGroup({
      [item.detailInfo.evideInputContentGuid]: new FormControl('')
    })
  }));

};


export interface IAttendanceContactListRowData {
  [key: string]: {
    evideInputContentGuid: string;
    detailInfo: DetailInfo;
    formGroup: FormGroup
  }
}

export const prepareColumnData = (
  gridRows: ReadonlyArray<IAttendanceGridRow>,
  attendanceContactInfos: ReadonlyArray<AttendanceContactInfo>,
  parentFormGroup: FormGroup,
  fb: FormBuilder
): Array<IAttendanceContactListRowData> => {
  return gridRows.map(item => {
    const rowData: IAttendanceContactListRowData = {};
    item.attendanceContactGridDatas.forEach(data => {
      const contactInfo: AttendanceContactInfo = attendanceContactInfos.find(item => data.evideInputContentGuid === item.evideInputContentGuid)
      if (contactInfo?.detailInfo) {
        const detailInfo = contactInfo.detailInfo;
        detailInfo.ruleParemeters = item.ruleParemeters;
        if (detailInfo) {
          detailInfo.value = data.dataStringGridValue;
          const formGroup = generateFormGroupForDetailInfo(fb.group({}), detailInfo);
          rowData[data.evideInputContentGuid] = {
            evideInputContentGuid: data.evideInputContentGuid,
            detailInfo: detailInfo,
            formGroup: formGroup
          };
          parentFormGroup.addControl(item.contactGuid, formGroup)
        }
      }
    });
    return rowData;
  });
};


export const generateFormGroupForAttendanceGridRow = (
  fb: FormBuilder, grid: AttendanceGridRow,
  attendanceContactInfos: Array<AttendanceContactInfo>
): FormGroup => {
  const formGroup = fb.group({});
  grid.attendanceContacts.forEach((contact) => {
    const contactInfo = attendanceContactInfos.find(item => item.evideInputContentGuid === contact.evideInputContentGuid);
    if (contactInfo) {
      const detailInfo = contactInfo.detailInfo.clone();
      detailInfo.ruleParemeters = grid.ruleParemeters;
      contact.detailInfo = detailInfo;
      contact.gridOrder = contactInfo.gridOrder;
      generateFormGroupForInputContent(contact, formGroup, detailInfo);
    }

  });
  attendanceContactInfos.sort((a, b) => a.gridOrder - b.gridOrder);
  return formGroup;
};

export const generateFormGroupForInputContent = (
  contact: AttendanceContact, forGroup: FormGroup, detailInfo: DetailInfo
): FormGroup => {
  const validators = [];
  if (detailInfo.isMandatory) {
    validators.push(Validators.required);
  }

  const inputControllerTypeName = detailInfo.controllerType;
  let editValue;
  if (inputControllerTypeName === InputControllerTypes.Dropdown && contact.dataStringGridValue) {
    const matchedOption = detailInfo.inputContentDatas?.find(opt => opt.value === contact.dataStringGridValue);
    editValue = matchedOption ? matchedOption.key : contact.dataStringGridValue;
  } else {
    editValue = contact.dataStringGridValue ? valueToControllerType(detailInfo.controllerType, contact.dataStringGridValue) : contact.dataStringGridValue;
  }

  if (inputControllerTypeName === InputControllerTypes.Checkboxes) {
    const val = [];
    if (contact.dataStringGridValue) {
      val.push(editValue)
    }
    forGroup.addControl(detailInfo.evideInputContentGuid, new FormControl(val, { validators }));
  } else {
    forGroup.addControl(detailInfo.evideInputContentGuid, new FormControl(editValue, { validators }));
  }

  return forGroup;
};

export const generateAttendanceGridRow = (
  grid: AttendanceGridRow,
  attendanceContactInfos: Array<AttendanceContactInfo>
): void => {
  grid.attendanceContacts.forEach((contact) => {
    const contactInfo = attendanceContactInfos.find(item => item.evideInputContentGuid === contact.evideInputContentGuid);
    if (contactInfo) {
      const detailInfo = contactInfo.detailInfo.clone();
      detailInfo.ruleParemeters = grid.ruleParemeters;
      contact.detailInfo = detailInfo;
      contact.gridOrder = contactInfo.gridOrder;
    }
  });
  attendanceContactInfos.sort((a, b) => a.gridOrder - b.gridOrder);
};

